import React, { useState, useEffect } from 'react';
import Card from '../../Components/share/cards/Card';
import EmptyPic from '../../Assets/Image/png/empty.png';
import { BtnPrimary } from '../../Components/share/buttons/Btn';
import { Modal } from '../../Components/share/modal/Modal';
import AdminIdeaModal from '../../Components/layouts/AdminDashboard/AdminIdeaModal';
import IdeaTable from '../../Components/layouts/AdminDashboard/IdeaTable';
import DashCard from '../../Components/share/cards/DashCard';
import { ReactComponent as Trash } from '../../Assets/Image/svg/trash.svg';
import { ReactComponent as Edit } from '../../Assets/Image/svg/edit.svg';
import { ReactComponent as Add } from '../../Assets/Image/svg/addSession.svg';
import AdminIdeaModalCourse from '../../Components/layouts/AdminDashboard/AdminIdeaModalCourse';
import useFetch from '../../Hooks/useFetch';
import moment from 'jalali-moment';

function AdminIdea() {
	const [show, setShow] = useState(false);
	const [list, setList] = useState();
	console.log('AdminIdea ~ list:', list);
	const [idea, setIdea] = useState(false);
	const [submitIdeaStatus, setSubmitIdeaStatus] = useState(false);

	const [del, setDel] = useState();
	const [edit, setEdit] = useState();

	const getIdeasService = useFetch({
		method: 'GET',
		url: `BootCampIdeasService/11/ideas`,
		noHeader: false,
		trigger: true,
		setter: setList,
	});
	//TODO : id bootcamp dynamic she

	const deleteIdeasService = useFetch({
		method: 'DELETE',
		url: `BootCampIdeasService/${del}`,
		noHeader: false,
		caller: getIdeasService,
	});

	const handleDelete = (id) => {
		setDel(id);
		deleteIdeasService.reFetch();
	};
	const handleEdit = (id) => {
		setEdit(id);
		console.log('edit');
		setShow(true);
		setSubmitIdeaStatus(false);
	};

	return (
		<div>
			{!idea ? (
				list?.results.length === 0 ? (
					<div>
						<Card>
							<div className=' pt-20 pb-24 px-[20rem] flex flex-col justify-center items-center mt-[5rem]'>
								<h3 className='font-bold text-[1.6rem] text-purple-dark mb-20'>
									اطلاعات ایده بوت کمپ
								</h3>
								<div className='mb-4'>
									<img src={EmptyPic} alt='EmptyPic' />
								</div>
								<p className=' text-[1.8rem] mb-14'>
									هنوز ایده ای برای این بوت کمپ ثبت نشده است!
								</p>
								<BtnPrimary
									text={'فعالسازی ثبت ایده برای افراد بوت کمپ'}
									className=' py-11 px-[7.8rem]'
									onClick={() => {
										setShow(true);
										//setIdea(true);
									}}
								/>
							</div>
						</Card>
					</div>
				) : (
					<div>
						<div className=' flex SupportTicket__header justify-between items-center mt-[5rem]'>
							<h3 className=' text-[#77498F] text-[1.6rem] font-bold'>
								اطلاعات ایده های بوت کمپ
							</h3>
						</div>
						{list?.results.map((i) => {
							return (
								<DashCard
									key={i.id}
									className='flex pt-[1.6rem] pb-[8.1rem] px-[1.6rem] flex-col mt-[4.5rem] w-11/12 mr-[0.4rem] mb-[5.6rem] shadow-btn bg-[#FBF7FF]'
								>
									<div className=' grid grid-cols-[1fr_1fr_0.25fr] gap-y-[1rem] gap-x-[2rem] items-center  justify-start'>
										<p className=' text-gray font-normal text-[1.8rem] leading-[3.2rem]  '>
											زمان فعال شدن ثبت ایده:
										</p>
										<p className=' text-[#000000] font-normal text-[1.8rem] leading-[3.2rem]'>
											{moment(i.idea_start_time)
												.locale('fa')
												.format('ddd DD MMMM YYYY')}
										</p>

										<div className='flex justify-around'>
											<div
												className='flex flex-col cursor-pointer'
												onClick={() => setIdea(true)}
											>
												<Add />
											</div>
											<div
												className='flex flex-col justify-center items-center cursor-pointer'
												onClick={() => handleDelete(i.id)}
											>
												<Trash />
											</div>

											<div
												className='flex flex-col cursor-pointer'
												onClick={() => handleEdit(i.id)}
											>
												<Edit />
											</div>
										</div>
										<p className=' text-gray font-normal text-[1.8rem] leading-[3.2rem] '>
											زمان غیر فعال شدن ثبت ایده:
										</p>
										<p className=' text-[#000000] font-normal text-[1.8rem] leading-[3.2rem]'>
											{moment(i.idea_end_time)
												.locale('fa')
												.format('ddd DD MMMM YYYY')}
										</p>
									</div>
								</DashCard>
							);
						})}
					</div>
				)
			) : (
				<div>
					<IdeaTable setIdea={setIdea} />
				</div>
			)}
			<Modal show={show}>
				<AdminIdeaModalCourse
					show={show}
					close={setShow}
					idea={list}
					setIdea={setIdea}
					submitIdeaStatus={submitIdeaStatus}
					setSubmitIdeaStatus={setSubmitIdeaStatus}
					getIdeasService={getIdeasService}
					edit={edit}
					setEdit={setEdit}
				/>
			</Modal>
		</div>
	);
}

export default AdminIdea;
